import { API_VERSIONS, asinzenAdminApi } from "client/api";

export const importMeltable = (query?: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "multipart/form-data",
    }
  })
    .post(`/${API_VERSIONS}/admin/meltable/import`, query);